import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiFetch from "../../Api";

const AuthPage = () => {
    const [loginUsername, setLoginUsername] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [registerUsername, setRegisterUsername] = useState('');
    const [registerPassword, setRegisterPassword] = useState('');
    const [message, setMessage] = useState({ type: '', text: '' });
    const [showRegisterForm, setShowRegisterForm] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('logout') !== null) {
            setMessage({ type: 'logout-message', text: 'Zostałeś wylogowany.' });
        } else if (params.get('error') !== null) {
            setMessage({ type: 'error-message', text: 'Nieprawidłowa nazwa użytkownika lub hasło.' });
        }
    }, [location.search]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            // W przyszłości tutaj będzie wywołanie endpointu /login w Spring Security
            // Na razie to jest tylko symulacja
            if (loginUsername && loginPassword) {
                // Przykład: wysłanie danych do Spring Security (prawdopodobnie formularz POST)
                const response = await apiFetch('/login', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: `username=${encodeURIComponent(loginUsername)}&password=${encodeURIComponent(loginPassword)}`,
                });

                if (response.ok) {
                    navigate('/home');
                } else {
                    const errorText = await response.text();
                    setMessage({ type: 'error-message', text: 'Logowanie nieudane. ' + errorText });
                }
            } else {
                setMessage({ type: 'error-message', text: 'Proszę uzupełnić dane logowania.' });
            }
        } catch (error) {
            console.error('Błąd logowania:', error);
            setMessage({ type: 'error-message', text: 'Wystąpił błąd podczas logowania.' });
        }
    };

    const handleRegistration = async (e) => {
        e.preventDefault();
        try {
            const response = await apiFetch('/api/registration', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `username=${encodeURIComponent(registerUsername)}&password=${encodeURIComponent(registerPassword)}`,
            });

            const data = await response.json();

            if (response.ok) {
                setMessage({ type: 'success-message', text: data.successMessage });
                setRegisterUsername('');
                setRegisterPassword('');
                setShowRegisterForm(false); // Ukryj formularz rejestracji po udanej rejestracji
            } else {
                setMessage({ type: 'error-message', text: data.errorMessage || 'Rejestracja nieudana.' });
            }
        } catch (error) {
            console.error('Błąd rejestracji:', error);
            setMessage({ type: 'error-message', text: 'Wystąpił błąd podczas rejestracji.' });
        }
    };

    return (
        <div>
            <header>
                <h2>Twoja droga do lepszych wyników</h2>
            </header>
            <div className="container">
                {message.text && (
                    <div className={`message ${message.type}`}>
                        {message.text}
                    </div>
                )}

                {!showRegisterForm && ( // Sekcja logowania widoczna tylko, gdy formularz rejestracji jest ukryty
                    <>
                        <h2>Logowanie</h2>
                        <form onSubmit={handleLogin}>
                            <div className="form-group">
                                <label htmlFor="usernameLogin">Nazwa użytkownika:</label>
                                <input
                                    type="text"
                                    id="usernameLogin"
                                    name="username"
                                    placeholder="Login"
                                    required
                                    value={loginUsername}
                                    onChange={(e) => setLoginUsername(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="passwordLogin">Hasło:</label>
                                <input
                                    type="password"
                                    id="passwordLogin"
                                    name="password"
                                    placeholder="Hasło"
                                    required
                                    value={loginPassword}
                                    onChange={(e) => setLoginPassword(e.target.value)}
                                />
                            </div>
                            <button type="submit">Zaloguj</button>
                        </form>

                        <p style={{ marginTop: '15px' }}>
                            Nie masz konta?{' '}
                            <button
                                type="button"
                                onClick={() => setShowRegisterForm(true)} // Pokazujemy formularz rejestracji
                                style={{ background: 'none', border: 'none', color: 'gray', textDecoration: 'underline', cursor: 'pointer' }}
                            >
                                Zarejestruj się
                            </button>
                        </p>
                    </>
                )}

                {showRegisterForm && ( // Formularz rejestracji widoczny tylko, gdy showRegisterForm jest 'true'
                    <>
                        <h2>Rejestracja</h2>
                        <form onSubmit={handleRegistration}>
                            <div className="form-group">
                                <label htmlFor="usernameRegister">Nazwa użytkownika:</label>
                                <input
                                    type="text"
                                    id="usernameRegister"
                                    name="username"
                                    placeholder="Login"
                                    required
                                    value={registerUsername}
                                    onChange={(e) => setRegisterUsername(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="passwordRegister">Hasło:</label>
                                <input
                                    type="password"
                                    id="passwordRegister"
                                    name="password"
                                    placeholder="Hasło"
                                    required
                                    value={registerPassword}
                                    onChange={(e) => setRegisterPassword(e.target.value)}
                                />
                            </div>
                            <button type="submit">Zarejestruj się</button>
                            <button
                                type="button"
                                onClick={() => setShowRegisterForm(false)}
                                style={{ marginLeft: '10px', background: 'none', border: 'none', color: 'gray', textDecoration: 'underline', cursor: 'pointer' }}
                            >
                                Anuluj
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default AuthPage;